import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const SurgeryPanelHeader = styled.div`
    ${media.mobileDevice`
    width:100%;
    position: fixed; 
    top:${(props) => (props.rquiredMargin ? props.rquiredMargin : '3.6rem')} ;
    background-color:#140f4b;
    z-index: 2000;
`}
`;

export const SurgeryPanelContentContainer = styled.div`
    display: flex;
    //padding: 2px 15px 23px 20px;
    /* margin: 5px 15px 19px 17px;
     */
    align-items: center;
    justify-content: space-between;
    width: 100%;
    //to make quick order header align
    /* margin: 0 0 9px 0;
    padding-top: 24px; */

    padding: 18px 0px;

    ${media.mobileDevice`
   // padding: 13px 0px;
        margin:0;
        padding:11px 0 1rem 15px;
     /* width: 94%; */
     /* padding-bottom: 1rem; */
    /* margin: 5px 15px 19px 17px; */
    `}
    .flexItems {
        width: 25%;
    }
`;

export const Title = styled.h2`
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    color: #140f4b;
    font-size: 24px;
    white-space: nowrap;

    ${media.mobileDevice`     
        color: #ffffff;
        //font size and space issue
        font-size: 22px;
        padding: ${({ padding }) => (padding ? padding : '0px')};
        font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 'bold')};
    `}

    .web {
        display: flex;
        color: #140f4b;
        align-items: center;

        ${media.mobileDevice`
            display: none
        `}
    }

    .mobile {
        display: none;

        ${media.mobileDevice`
            display: block;
        `}
    }
`;

export const IconsContainer = styled.div`
    display: flex;
    justify-content: space-around;
    ${media.mobileDevice`
         width: 21%;
    `}
`;

export const Icon = styled.div`
    background: url(${(props) => props.deskPath});
    height: 2.7rem;
    width: 2.7rem;
    cursor: pointer;
    background-repeat: no-repeat;
    position: relative;
    margin-right: ${(props) =>
        props.marginRightDesktop ? props.marginRightDesktop : '0px'};
    ${media.mobileDevice`
        background: url(${(props) => props.mobilePath});
        background-repeat: no-repeat;
        margin-right: ${(props) =>
            props.marginRightMobile ? props.marginRightMobile : '0px'};
        bottom: ${(props) => props.bottom};
    `}
`;

export const IconPlaceHolder = styled.div`
    margin: ${({ margin }) => margin};
    /* border: 1px solid #140f4b; */
    opacity: 1;
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    //to make quick order header align
    /* margin-right: 17px;
     */
    ${'' /* margin-right: 10px; */}
    ${media.mobileDevice`
        margin-right : ${({ marginRight }) =>
            marginRight ? marginRight : '0px'};
    `}
`;

export const CountLabel = styled.span`
    background-color: ${(props) => (props.colorNote ? '#ffffff' : '#12C8F7')};
    padding: 0px 2px;
    color: #140f4b;
    border-radius: 47%;
    border: 1px solid #140f4b;
    margin: 0px 0px 0px 19px;
    width: 18px;
    height: 18px;
    font-size: 12px;

    position: absolute;
    text-align: center;

    font-family: 'AvenirNextWorld Bold';
    ${media.mobileDevice`
    padding: 0px 1px;
    background-color: ${(props) => props.backgroundColor};
    border : ${(props) => props.border};
    color : ${(props) => (props.colorNote ? '#ffffff' : '#140F4B')};
    `}
`;

export const CountContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    right: ${(props) => (props.right ? props.right : '-1px')};
    top: ${(props) => (props.top ? props.top : '-11px')};
    position: absolute;
    background-color: ${(props) => (props.colorNote ? '#F5F5F5' : '#12C8F7')};
    width: ${(props) => (props.width ? props.width : '27px')};
    height: ${(props) => (props.height ? props.height : '27px')};
    border-radius: 50%;
    border: ${(props) =>
        props.desktopBorder ? props.desktopBorder : '1px solid #140f4b'};
    ${media.mobileDevice`
        right: ${(props) => (props.mbRight ? props.mbRight : '-1px')};
        top: ${(props) => (props.mbTop ? props.mbTop : '-12px')};
        background-color: ${(props) => props.backgroundColor};
        border : ${(props) => props.border};
    `}
`;

export const LabelCount = styled.span`
    display: inline-block;
    color: #140f4b;
    font-size: 12px;
    position: absolute;
    text-align: center;
    letter-spacing: -0.1px;
    line-height: 21px;
    font-family: 'AvenirNextWorld Demi';
    vertical-align: middle;
    width: 100%;
    ${media.mobileDevice`
        
        color : ${(props) => (props.colorNote ? '#ffffff' : '#140F4B')};
    `}
`;

export const Back = styled.label`
    width: 32px;
    height: 22px;
    text-align: left;
    font-size: 13px;
    color: #1010eb;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    cursor: pointer;

    ${media.mobileDevice`
        display: none
    `}
`;

export const SurgeryNoteBack = styled.label`
    width: 32px;
    height: 22px;
    text-align: left;
    font-size: 13px;
    color: #1010eb;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    cursor: pointer;
    margin-right: 360px;
    margin-top: 15px;

    ${media.mediumDevice`
            margin-right: 300px;
        `}

    ${media.smalDevice`
            margin-right: 240px;
        `}
`;

export const BackIcon = styled.div`
    margin-top: 9px;
    ${media.mobileDevice`
display: none
`}
`;

export const Border = styled.div`
    width: 100%;
    height: 0px;
    border-top: 1px solid #707070;
    opacity: 0.2;
    margin: ${({ margin }) => (margin ? margin : '20px 0')};
    align-self: center;
    background-color: #707070;
    z-index: -1;
    position: absolute;
    top: 135px;
    ${media.mobileDevice`
        display: none
    `}
`;

export const HospitalNames = styled.div`
    /* width: 165px; */
    height: 21px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #140f4b;
    white-space: nowrap;
    margin: 0 2px 0 0;
    text-align: right;
    text-overflow: ellipsis;
    overflow: ${({ overflow }) => (overflow ? overflow : 'hidden')};
`;

export const Number = styled.div`
    width: ${({ accountIdWidth }) =>
        accountIdWidth ? accountIdWidth : '49px'};
    height: 21px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Italic'};
    letter-spacing: 0px;
    color: #140f4b;
`;

export const Div = styled.div`
    display: flex;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : 'auto')};
    /* margin-right: 50px;
    margin-top: 10px; */
    position: absolute;
    right: 104px;
    top: 89px;
    ${media.mobileDevice`
    text-align:left;
   `}
`;

export const UnId = styled.div`
    width: 33px;
    height: 21px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: 0px;
    color: #4f4f4f;
`;

export const UnIdNumber = styled.div`
    width: auto;
    height: 21px;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    letter-spacing: 0px;
    color: ${({ color }) => (color ? color : '#1010eb')};
    margin-left: 5px;
    margin-right: 5px;
    cursor: ${({ cursor }) => cursor};
`;

export const Status = styled.div`
    display: flex;
    /* width: 97px; */
    height: 21px;
    text-align: left;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: 0px;
    color: #140f4b;
    opacity: 1;
`;

export const DisplayDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: ${({ width }) => (width ? width : '30%')};
    ${media.mediumDevice`
        width: 30%;
    `}
    ${media.smalDevice`
            width: auto;
        `}
    @media screen and (orientation:landscape) {
        width: 35%;
    }
    justify-content: flex-end;
    ${media.mobileDevice`
    display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'none')};
    
`}
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'column'};
    justify-content: ${({ justifyContent }) => justifyContent};
    width: ${({ width }) => (width ? width : '50%')};
    ${media.mediumDevice`
        width: ${({ width }) => (width ? width : '45%')};
    `}
    ${media.smalDevice`
        width: ${({ width }) => (width ? width : '45%')};
    `}
    ${media.mobileDevice`
        width:auto;
    `}
`;

export const ModifyDetailContainer = styled.div`
    display: flex;
    align-items: center;
    margin: ${({ margin }) => margin};
    ${media.mobileDevice`
            display: none
    `}
`;

export const ModifyDetails = styled.div`
    margin: ${({ margin }) => (margin ? margin : '0')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    letter-spacing: 0px;
    color: #202124;
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '19px')};
`;
export const TitleProductMethod = styled.h2`
    font-family: 'AvenirNextWorld Demi';
    margin: 0;
    color: #140f4b;
    font-size: 24px;
    position: absolute;
    left: calc(100% / 2 - 50% / 8);

    ${media.mobileDevice`     
        color: #ffffff;
        //font size and space issue
        font-size: 22px;
        padding: ${({ padding }) => (padding ? padding : '0px')};
        font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 'bold')};
        left: calc(100% /2 - calc(100% / 2 - 25%));
    `}

    ${media.exSmallDevice`
        left: calc(100% /2 - 60% /2);
    `}
    

    .web {
        display: flex;
        color: #140f4b;
        align-items: center;

        ${media.mobileDevice`
            display: none
        `}
    }

    .mobile {
        display: none;

        ${media.mobileDevice`
            display: block;
        `}
    }
`;

export const DisplayDivAccount = styled.div`
    display: flex;
    flex-direction: column;
    width: ${({ width }) => (width ? width : '30%')};
    justify-content: flex-end;
    ${media.mediumDevice`
            width: 30%;
        `}
    ${media.smalDevice`
             width: auto;
        `}
        ${media.mobileDevice`
            display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'none')};
        `}

        @media screen and (orientation:landscape) {
        ${media.mediumDevice`
                display: none;
            `}
    }
    @media all and (width: 990px) and (height: 420px) and (orientation: landscape) {
        display: none !important;
    }
`;

export const DisplayDivCart = styled.div`
    display: flex;
    justify-content: flex-end;
    width: ${({ width }) => (width ? width : '30%')};
    ${media.mediumDevice`
        width: 30%;
        @media screen and (orientation: portrait) {
            float: right;
            width: 100%;
            text-align: right;
            margin-right: 15px;
        }
    `}
    @media screen and (orientation:landscape) {
        float: right;
        width: 100%;
        text-align: right;
        margin-right: 15px;
    }
    ${media.mobileDevice`
    display: ${({ mbDisplay }) => (mbDisplay ? mbDisplay : 'none')};
    
`}
`;
export const DivCart = styled.div`
    display: flex;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : 'auto')};
    position: relative;
    ${media.mobileDevice`
    text-align:left;
   `}
`;

export const TitleProductGuide = styled(TitleProductMethod)`
    ${media.mobileDevice`
        padding-left: 18px;
    `}
`;
